import { currencySymbols } from '../../../../constants'
import { ECurrency } from '../../../../types/enums'

export const currencyOptions: {
  value: ECurrency | ''
  label: string
  disabled?: boolean
}[] = [
  { value: ECurrency.TON, label: `TON (${currencySymbols[ECurrency.TON]})` },
  {
    value: ECurrency.USDT,
    label: `USDT (${currencySymbols[ECurrency.USDT]})`,
    disabled: true,
  },
  { value: '', label: '', disabled: true },
  { value: ECurrency.USD, label: `USD (${currencySymbols[ECurrency.USD]})` },
  { value: ECurrency.EUR, label: `EUR (${currencySymbols[ECurrency.EUR]})` },
  { value: ECurrency.GBP, label: `GBP (${currencySymbols[ECurrency.GBP]})` },
  { value: ECurrency.JPY, label: `JPY (${currencySymbols[ECurrency.JPY]})` },
  { value: ECurrency.CNY, label: `CNY (${currencySymbols[ECurrency.CNY]})` },
  { value: ECurrency.INR, label: `INR (${currencySymbols[ECurrency.INR]})` },
  { value: ECurrency.BRL, label: `BRL (${currencySymbols[ECurrency.BRL]})` },
  { value: ECurrency.RUB, label: `RUB (${currencySymbols[ECurrency.RUB]})` },
  // { value: ECurrency.AED, label: `AED (${currencySymbols[ECurrency.AED]})` },
  { value: ECurrency.NONE, label: 'No Currency' },
]
